import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WindowService {

  public navigate(route: string): void {
    window.location.href = encodeURI(`${window.location.origin}#${route}`);
  }

  public toOrigin(): void {
    window.location.href = encodeURI(window.location.origin);
  }
}
